var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 .396C.198.136.459.031.803.031c2.703.021 5.333.418 7.9 1.253.616.198.72.396.522 1.012a6678.362 6678.362 0 0 1-3.486 11.187c-.146.459-.281.918-.407 1.388-.104.386-.334.563-.73.563-1.305-.01-2.599-.01-3.903 0-.324 0-.532-.146-.71-.396C0 10.154 0 5.27 0 .396ZM5.55 4.748A1.993 1.993 0 0 0 3.57 2.713a1.991 1.991 0 0 0-2.025 1.983 2 2 0 0 0 2.014 2.035 1.998 1.998 0 0 0 1.993-1.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.142 24.545a6.6 6.6 0 0 1-3.37-.178c-1.837-.563-3.35-1.66-4.76-2.911-2.15-1.91-3.965-4.143-5.77-6.366-.313-.397-.783-.762-.877-1.21-.083-.429.24-.94.386-1.41.919-2.921 1.837-5.833 2.755-8.755.032-.115.073-.22.115-.344h4.738c-.136.135-.23.219-.334.313-1.065.98-1.972 2.076-2.536 3.433-.26.626-.386 1.273-.209 1.951.313 1.18 1.42 1.983 2.797 2.056 1.45.073 2.536-.595 3.36-1.711.25-.345.49-.46.919-.376.782.146 1.45-.146 2.056-.689.772.668 1.544 1.326 2.306 1.994 2.64 2.306 5.27 4.623 7.701 7.158.21.22.407.439.606.658.647.73.626 1.774-.052 2.431-.668.648-1.691.658-2.39-.041-1.743-1.733-3.475-3.496-5.208-5.25-.083-.083-.156-.208-.25-.24-.136-.041-.303-.02-.449-.02 0 .146-.031.313.01.448.021.084.136.146.21.23 1.544 1.555 3.088 3.1 4.633 4.654.417.428.751.887.845 1.503.115.825-.386 1.482-1.21 1.534-.668.042-1.242-.188-1.722-.668-1.973-1.983-3.956-3.965-5.938-5.948-.084-.084-.157-.209-.261-.23-.125-.031-.313-.031-.407.042-.063.052-.052.261-.021.376.031.104.146.177.23.26 1.69 1.702 3.38 3.403 5.082 5.093.407.407.626.866.511 1.44a1.47 1.47 0 0 1-2.41.825 3.891 3.891 0 0 1-.366-.355l-6.136-6.136c-.084-.084-.157-.209-.25-.24-.126-.042-.355-.063-.408 0-.073.104-.052.292-.02.438.02.084.135.157.208.23 1.868 1.878 3.736 3.746 5.604 5.625.105.104.22.187.324.281 0 .032-.021.063-.042.105Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M21.122 1.711a29.44 29.44 0 0 1 8.964 1.576c.282.094.407.25.49.522 1.076 3.444 2.16 6.877 3.267 10.31.104.334.042.47-.26.637-.971.532-1.921 1.085-2.881 1.649-.22.125-.344.115-.522-.073-2.995-2.995-6.199-5.771-9.402-8.526-.386-.334-.45-.324-.793.042-.439.448-.971.667-1.597.532-.637-.146-1.054.073-1.43.595-.657.918-1.534 1.565-2.713 1.482-.522-.032-1.075-.22-1.545-.47-.688-.355-1.001-1.18-.824-1.941.26-1.158.908-2.098 1.68-2.964 1.378-1.544 2.964-2.797 5.061-3.172.804-.126 1.66-.126 2.505-.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M40 7.618v6.773c0 .647-.168.814-.804.814h-3.83c-.522 0-.626-.126-.783-.627-.678-2.201-1.367-4.393-2.056-6.595l-1.784-5.698c-.198-.626-.063-.855.563-1.012a51.25 51.25 0 0 1 7.65-1.242c.094-.01.177-.01.271-.02.553-.022.762.177.762.73.01 2.285.01 4.581.01 6.877Zm-3.946-4.905a2.007 2.007 0 0 0-2.045 1.972c-.031 1.096.877 2.025 1.983 2.046 1.106.02 2.035-.877 2.045-1.973a2.016 2.016 0 0 0-1.983-2.045Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M3.569 3.36c.762 0 1.357.616 1.357 1.378a1.379 1.379 0 0 1-1.367 1.367 1.375 1.375 0 0 1-1.367-1.41c0-.761.605-1.345 1.377-1.335Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M34.656 4.717c0-.762.595-1.357 1.367-1.357.752 0 1.378.606 1.378 1.357.01.762-.637 1.398-1.399 1.388a1.38 1.38 0 0 1-1.346-1.388Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 7.321,
    x2: -2.102,
    y1: 2.532,
    y2: 6.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 26.117,
    x2: 8.546,
    y1: 6.876,
    y2: 21.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.17,
    x2: 17.049,
    y1: 4.111,
    y2: 17.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 38.001,
    x2: 28.611,
    y1: 2.476,
    y2: 6.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4.341,
    x2: 2.186,
    y1: 3.806,
    y2: 5.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 36.814,
    x2: 34.656,
    y1: 3.806,
    y2: 5.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v24.952H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab);
export default __webpack_public_path__ + "static/media/Collab.a9ec1126407b1300132e09148a1bd60e.svg";
export { ForwardRef as ReactComponent };